import {en,el,tr,mk} from 'vuejs-datepicker/dist/locale'

export const vCalendarSq = {
    id: 'sq',
    firstDayOfWeek: 2,
    dayNames: ['E diel', 'E hënë', 'E martë', 'E mërkurë', 'E enjte', 'E premte', 'E shtunë'],
    dayNamesShort:  ['Die', 'Hën', 'Mar', 'Mër', 'Enj', 'Pre', 'Sht'],
    dayNamesShorter: ['Di', 'Hë', 'Ma', 'Më', 'En', 'Pr', 'Sh'],
    dayNamesNarrow: ['D', 'H', 'M', 'M', 'E', 'P', 'Sh'],
    monthNames: ['Janar', 'Shkurt', 'Mars', 'Prill', 'Maj', 'Qershor', 'Korrik', 'Gusht', 'Shtator', 'Tetore', 'Nëntor', 'Dhjetor'],
    monthNamesShort: ['Jan', 'Shku', 'Mar', 'Pri', 'Maj', 'Qer', 'Korr', 'Gush', 'Shta', 'Tet', 'Nën', 'Dhje'],
    masks: {
        L: "DD-MM-YYYY",
        input: "DD-MM-YYYY",
        data: "DD-MM-YYYY"
    }
}

export const datePickerSQ = {
    language: 'Albanian',
    months:  ['Janar', 'Shkurt', 'Mars', 'Prill', 'Maj', 'Qershor', 'Korrik', 'Gusht', 'Shtator', 'Tetor', 'Nëntor', 'Dhjetor'],
    monthsAbbr: ['Jan', 'Shku', 'Mar', 'Pri', 'Maj', 'Qer', 'Korr', 'Gush', 'Shta', 'Tet', 'Nën', 'Dhje'],
    days:  ['Di', 'Hë', 'Ma', 'Më', 'En', 'Pr', 'Sh'],
    rtl: false,
    ymd: false,
    yearSuffix: '',
    mondayFirst: true
}

export const datePickerLanguage = () => {
    const langguages = {
        en,mk,el,tr,sq: datePickerSQ
    }

   return langguages[currentLanguage()] ?? en;
}

export const currentLanguage = () => {
    return document.documentElement.lang
}

export const fullCalendarLocaleSQ = {
    code: 'sq',

    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
    buttonText: {
        prev: 'Pas',
        next: 'Para',
        today: 'Sot',
        month: 'Muaj',
        week: 'Javë',
        day: 'Ditë',
        list: 'Lista',
    },
    buttonHints: {
        prev: 'Pas $0',
        next: 'Para $0',
        today: 'Sot $0',
    },
    viewHint: 'shfaq $0',
    weekText: 'Java',
    navLinkHint: 'Shko tek $0',
    moreLinkHint(eventCnt) {
        return `Shfaq ${eventCnt} event${eventCnt === 1 ? '' : 'e'} më shumë`
    },
};

export default fullCalendarLocaleSQ
